import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Drawer } from '@material-ui/core';
import { connect } from 'react-redux';
import { logoutUser } from '../../actions/formActions';
import logo from '../../images/frozberries-logo.png';

const NAV_ITEMS = [
  { href: '/adminpanel', icon: 'fas fa-chart-bar', label: 'Dashboard' },
  { href: '/adminpanel/orders', icon: 'fas fa-shopping-bag', label: 'Orders' },
  { href: '/adminpanel/users', icon: 'fas fa-users', label: 'Customers' },
  { href: '/adminpanel/products', icon: 'fas fa-tag', label: 'Products' },
  { href: '/adminpanel/recipes', icon: 'fas fa-concierge-bell', label: 'Recipes' },
  { href: '/adminpanel/coupons', icon: 'fas fa-percent', label: 'Coupons' },
  { href: '/adminpanel/reviews', icon: 'far fa-comment', label: 'Reviews' },
  { href: '/adminpanel/settings', icon: 'fas fa-cog', label: 'Settings' },
];

const SideBarContent = ({ auth, logoutUser, onNavClick }: any) => {
  const location = useLocation();
  const history = useHistory();

  const onLogoutClick = () => {
    logoutUser();
    history.push('/login');
  };

  return (
    <div className="admin-sidebar-inner">
      <div className="admin-sidebar-logo">
        <a href="/">
          <img src={logo} alt="Frozberries Victoria" />
        </a>
      </div>

      <nav className="admin-sidebar-nav">
        {NAV_ITEMS.map(({ href, icon, label }) => {
          const active =
            href === '/adminpanel'
              ? location.pathname === '/adminpanel'
              : location.pathname.startsWith(href);
          return (
            <a
              key={href}
              href={href}
              className={`admin-sidebar-item${active ? ' active' : ''}`}
              onClick={onNavClick}
            >
              <i className={`${icon} admin-sidebar-icon`} />
              <span>{label}</span>
            </a>
          );
        })}
      </nav>

      <div className="admin-sidebar-user">
        <div className="admin-sidebar-user-name">
          <i className="fas fa-user-circle admin-sidebar-icon" />
          <span>{auth.user.firstName}</span>
        </div>
        <div className="admin-sidebar-user-actions">
          <a href="/" className="admin-sidebar-user-link">
            Home
          </a>
          <button className="admin-sidebar-user-link" onClick={onLogoutClick}>
            Log out
          </button>
        </div>
      </div>
    </div>
  );
};

const SideBar = ({ auth, logoutUser, mobileOpen, onClose }: any) => {
  return (
    <>
      {/* Desktop — always visible */}
      <aside className="admin-sidebar admin-sidebar-desktop">
        <SideBarContent auth={auth} logoutUser={logoutUser} />
      </aside>

      {/* Mobile — MUI Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={onClose}>
        <div style={{ width: 240, height: '100%' }}>
          <SideBarContent auth={auth} logoutUser={logoutUser} onNavClick={onClose} />
        </div>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  auth: state.form,
});

export default connect(mapStateToProps, { logoutUser })(SideBar);
